import Icon from 'veui/components/Icon'
import { IconLineChartAlt } from 'dls-icons-vue'

Icon.register('line-chart-alt', IconLineChartAlt)
